import type { SessionCompletionCheck } from "@opencode-ai/sdk/v2/client"

export function currentChecks(checks: SessionCompletionCheck[]) {
  return checks.filter(
    (check, index) => checks.findLastIndex((candidate) => candidate.command.trim() === check.command.trim()) === index,
  )
}
